import React from 'react';
import { isValidNumber, parse } from 'libphonenumber-js';
import { noop } from 'lodash';

import fromAnyToSpacelessString from 'utils/converters/fromAnyToSpacelessString.util';
import nullBind from 'utils/functions/nullBind.util';

import InputField from 'onboarding/common/InputField';

const USE_LIB = false; // NOTE: change this back to false after development
const COUNTRY_CODE = 'GB';

const validateUKPhone = (value) => {
  // eslint-disable-next-line max-len,no-useless-escape
  const ukRegex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;
  return ukRegex.test(value);
};

const validateUsingLib = (onPhoneNumberValid, value) => {
  // We need to know what country we expect the user to be in, because she probably won't type her country code in
  // phones starts with 0204...0205, 0206 and 0209 are valid UK but libphonenumber-js make them invalid
  const parsedNumber = parse(fromAnyToSpacelessString(value), COUNTRY_CODE);
  try {
    if (isValidNumber(parsedNumber)) {
      onPhoneNumberValid(true, value);
      return '';
    }
  } catch (error) {
    if (error instanceof TypeError) {
      onPhoneNumberValid(false, value);
      return 'Please enter a valid phone number';
    }
    throw error;
  }
  onPhoneNumberValid(false, value);
  return 'Please enter a valid phone number';
};

const validateUsingRxp = (onPhoneNumberValid, value) => {
  if (/^[0-9+)(\s]*$/.test(value)) {
    onPhoneNumberValid(true, value);
  }
  if (value.length !== 0 && !validateUKPhone(value)) {
    return 'Please enter valid phone number';
  }
  return '';
};

const validatePhoneNumberSymbol = (value) => {
  const phoneSymbolsRegex = /^[0-9+)(\s]*$/;
  return phoneSymbolsRegex.test(value);
};

const PhoneNumberInput = ({ data, onPhoneNumberChange, onPhoneNumberValid = noop }) => (
  <InputField
    data={data}
    onChangeHandler={onPhoneNumberChange}
    validateChange={nullBind(validatePhoneNumberSymbol, onPhoneNumberValid)}
    validateBlur={nullBind(USE_LIB ? validateUsingLib : validateUsingRxp, onPhoneNumberValid)}
  />
);

export default PhoneNumberInput;
